//@ts-check
import React, { useCallback, useState, useEffect } from "react";
import { useAppDispatch } from "src/utils/ReduxHooks";

import useTypedSelector from "utils/useTypedSelector";
import LnIcon from "components/LnIcon";
import { userDuck } from "./UserDuck";
import { LoginDuck } from "features/login/LoginDuck";
import UserDataReadOnly from "./UserDataReadOnly";
import UserDataEditForm from "./UserDataEditForm";


/**
 * 
 * @param {{userData: import('./User').UserDetailDto , t: import('features/language/languageService').LanguageService}} props 
 */
const UserDataGeneral = ({ userData, t }) => {
    
    /** @type {import('redux').Dispatch<any>} */
    const dispatch = useAppDispatch();
    const user = useTypedSelector(state => state.login.user);

    const [editMode, setEditMode] = useState(userData && (!user.HasShadow && userData.Id === user.Id && userData.CanEdit && userData.Federated === 0));
    const [shadow, setShadow] = useState(true);


    useEffect(() => {
        setEditMode(userData && (!user.HasShadow && userData.Id === user.Id && userData.CanEdit && userData.Federated === 0));
    }, [userData, user])

    /**
    *
    * @param {number} type
    */
    const sendEmailVerification = (type) => {
        dispatch(userDuck.sendVerifyEmail(userData.Id, type));
    }

    const switchUsr = useCallback(() => {
        dispatch(LoginDuck.switchUser(userData.Id, shadow));
    }, [shadow, dispatch, userData.Id]);



    const toggleEditMode = () => {
        setEditMode(!editMode);
    }


    return (
        <div className=" pt-4">
            <div className="d-flex justify-content-between mb-4">
                <div>
                    {userData.Teacher && 
                    <div>
                        {t.getText('latest.activity')}
                        <strong className="ml-2">
                            {t.getMediumDateTimeString(userData.Info.LastActive)}
                        </strong>
                    </div>
                    }
                    {userData.CanEdit &&
                        <div className="mt-3">
                            {t.getText('date.created')}
                            <strong className="ml-2">
                                {t.getMediumDateString(userData.Created)}
                            </strong>
                        </div>
                    }

                    {userData.Teacher && userData.Teacher.ArchivedClasses?.length > 0 &&
                        <div className="d-flex mt-3">
                            <div className="mr-3">{t.getText('archived')}</div>
                            <ul className="pl-5">
                                {userData.Teacher.ArchivedClasses.map(cl =>
                                    <li key={cl.Id}>{cl.Name}</li>
                                )}
                            </ul>

                        </div>
                    }

                </div>
                <div className="d-flex">

                    {!user.HasShadow && userData.CanEdit && userData.Federated === 0 && !editMode &&
                            <button type="button" className="btn btn-small btn-inverse w-100" onClick={() => toggleEditMode()}>
                                <LnIcon className="icon-small mr-4" name="edit-icon" /> {t.getText('edit')}
                            </button>
                    }

                    {user.CanSwitchUser && userData.Teacher?.CanSwitchUser &&
                        <div className="ml-3 d-flex flex-column align-content-end">
                            <button type="button" onClick={switchUsr} className="btn btn-small btn-inverse btn-danger">{t.getText("switch.user")}</button>
                            {user.IsRoot && <div className="custom-control custom-switch">
                                <input type="checkbox" checked={shadow} onChange={() => setShadow(!shadow)} className="custom-control-input" id="customSwitch1" />
                                <label className="custom-control-label" htmlFor="customSwitch1">Shadow</label>
                            </div>}
                        </div>
                    }
                </div>


            </div>


            {!editMode && <UserDataReadOnly userData={userData} t={t} sendEmailVerification={sendEmailVerification} />}

            {editMode && <UserDataEditForm onCancelForm={() => setEditMode(false)} userData={userData} t={t} />}

        </div>
    )

}


export default UserDataGeneral;

